// extracted by mini-css-extract-plugin
export default {"card":"style_card__xajBz","header":"style_header__x1lS5","checkbox":"style_checkbox__8mcAj","name":"style_name__swQCx","total":"style_total__93yA5","body":"style_body__9bygR"};